import * as queries from "./queries"
import * as mutations from "./mutations"

export const implementer = {
  queries: queries,
  mutations: mutations
}
